import gql from 'graphql-tag';

export const gqlGetCpGroups = gql`
  query getCpGroups($where: String, $offset: Int, $limit: Int, $order: String) {
    getCpGroups(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        name
        code
      }
      recordCount
    }
  }
`;

export const gqlGetCpGroup = gql`
  query getCpGroupById($id: Int) {
    getCpGroupById(id: $id) {
      name
      code
      firstDate
      lastDate
      firstUser
      lastUser
    }
  }
`;

export const gqlAddCpGroup = gql`
  mutation addCpGroup($data: CpGroupInput) {
    addCpGroup(data: $data) {
      id
    }
  }
`;

export const gqlUpdateCpGroup = gql`
  mutation updateCpGroup($data: CpGroupInput) {
    updateCpGroup(data: $data) {
      id
    }
  }
`;

export const gqlDeleteCpGroup = gql`
  mutation deleteCpGroup($id: Int) {
    deleteCpGroup(id: $id)
  }
`;

export const gqlGetCpSubgroups = gql`
  query getCpSubgroups($where: String, $offset: Int, $limit: Int, $order: String) {
    getCpSubgroups(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        name
        code
        groupId
      }
      recordCount
    }
  }
`;

export const gqlGetCpSubgroup = gql`
  query getCpSubgroupById($id: Int) {
    getCpSubgroupById(id: $id) {
      name
      code
      groupId
      cpGroup {
        id
        name
      }
      firstDate
      lastDate
      firstUser
      lastUser
    }
  }
`;

export const gqlAddCpSubgroup = gql`
  mutation addCpSubgroup($data: CpSubgroupInput) {
    addCpSubgroup(data: $data) {
      id
    }
  }
`;

export const gqlUpdateCpSubgroup = gql`
  mutation updateCpSubgroup($data: CpSubgroupInput) {
    updateCpSubgroup(data: $data) {
      id
    }
  }
`;

export const gqlDeleteCpSubgroup = gql`
  mutation deleteCpSubgGroup($id: Int) {
    deleteCpSubgroup(id: $id)
  }
`;

export const gqlGetCpSubsubgroups = gql`
  query getCpSubsubgroups($where: String, $offset: Int, $limit: Int, $order: String) {
    getCpSubsubgroups(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        name
        code
        subgroupId
        cpSubgroup {
          groupId
        }
      }
      recordCount
    }
  }
`;

export const gqlGetCpSubsubgroup = gql`
  query getCpSubsubgroupById($id: Int) {
    getCpSubsubgroupById(id: $id) {
      name
      code
      subgroupId
      cpSubgroup {
        groupId
        name
        cpGroup {
          name
          id
        }
      }
      firstDate
      lastDate
      firstUser
      lastUser
    }
  }
`;

export const gqlAddCpSubsubgroup = gql`
  mutation addCpSubsubgroup($data: CpSubsubgroupInput) {
    addCpSubsubgroup(data: $data) {
      id
    }
  }
`;

export const gqlUpdateCpSubsubgroup = gql`
  mutation updateCpSubsubgroup($data: CpSubsubgroupInput) {
    updateCpSubsubgroup(data: $data) {
      id
    }
  }
`;

export const gqlDeleteCpSubsubgroup = gql`
  mutation deleteCpSubsubgGroup($id: Int) {
    deleteCpSubsubgroup(id: $id)
  }
`;

export const gqlGetCpGroupsFlatview = gql`
  query getCpGroupsFlatview($where: String, $offset: Int, $limit: Int, $order: String) {
    getCpGroupsFlatview(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        groupId
        groupName
        subgroupId
        subgroupName
        subsubgroupId
        subsubgroupName
      }
      recordCount
    }
  }
`;
